import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Stack,
  CircularProgress,
} from "@mui/material";
import { UpdateCountry } from "./UpdateCountry";
import {
  AlertDialog,
  MgpButton,
  MgpModal,
  MgpTable,
  MgpText,
  MgpTextboxFormik,
  TableConfig,
} from "../../../components/global";
import { Tooltip } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useCountry, useRbac } from "../../../hooks";
import {
  MRT_FilterTextField,
  MRT_GlobalFilterTextField,
  MRT_ToggleDensePaddingButton,
  MRT_ToggleFullScreenButton,
  MRT_ToggleGlobalFilterButton,
  useMaterialReactTable,
} from "material-react-table";
import Loader from "../../Loader/Loader";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import MgpAlertBar from "../../../components/global/MgpAlertBar";
import { downloadPdf } from "../../../helpers/dowloadPdf.js";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { downloadExcel } from "../../../helpers/downloadExcel.js";

export const Country = () => {
  const [open, setOpen] = useState(false);
  const [delete_ref, setDeleting] = useState(false);
  const [mainPageloading, setMainPageloading] = useState(true);
  const [alertType,setAlertType] = useState("");
  const [message, setMessage] = useState("");
  const [alertOption, setAlertOption] = useState(false);
  const { useGetCountries, useDeleteCountry, GET_COUNTRIES } = useCountry();
  const [edit, setEdit] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const { RbacWrapper } = useRbac();
  const [GetCountries, { data, loading, error }] = useGetCountries;
  const [DeleteCountry] = useDeleteCountry;
  const handleNew = () => {
    setEdit({});
    setOpen(true);
  };
  useEffect(() => {
    GetCountries();
  }, [GetCountries]);
  const handleExportData = (type) => {
    const filteredData = table
      .getFilteredRowModel()
      .rows.map((row) => row.original)
      .map((obj) => {
        const filteredObj = {};
        columns.forEach((key) => {
          if (obj.hasOwnProperty(key.accessorKey)) {
            if (key.accessorKey === "is_gcc") {
              filteredObj[key.header] = obj[key.accessorKey] ? "Yes" : "No"
            } else if (key.accessorKey === "collect_pii") {
              filteredObj[key.header] = obj[key.accessorKey] === false ? "No" : "Yes"
            } else {
              filteredObj[key.header] = obj[key.accessorKey];

            }

          }
        });
        return filteredObj;
      });
    let dataToExport = filteredData ? filteredData : data.rows;
    let filename = "Countries List MG";
    if (dataToExport.length) {
      if (type === "xlsx") {
        downloadExcel(dataToExport, filename)
      } else {
        downloadPdf(dataToExport, filename);
      }
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "country_name", //access nested data with dot notation
        header: "Country",
      },
      {
        accessorKey: "country_code",
        header: "Country Code",
      },
      // {
      //   accessorKey: "is_saudi",
      //   header: "Nationality",
      //   Cell: ({ renderedCellValue, row }) => {
      //     return <span>{row.original.is_saudi ? 'Saudi' : 'Non Saudi'}</span>
      //   }
      // },
      {
        accessorKey: "is_gcc",
        header: "GCC country",
        Cell: ({ renderedCellValue, row }) => {
          return <span>{row.original.is_gcc ? 'Yes' : 'No'}</span>
        }
      },
      {
        accessorKey: "collect_pii",
        header: "Collect patient identification",
        Cell: ({ row }) => {
          return <span>{row.original.collect_pii === false ? 'No' : 'Yes'}</span>
        }
      },
      {
        accessorKey: "created_on", //normal accessorKey
        header: "Created On",
      },

    ],
    []
  );
  useEffect(() => {
    if (data || error) {
      setMainPageloading(false);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  }, [data, error]);
  const table = useMaterialReactTable({
    columns,
    data: data?.GetCountries ?? [],
    ...TableConfig,
    enableRowActions: true,
    muiSearchTextFieldProps: {
      size: "small",
      variant: "outlined",
    },

    renderTopToolbar: ({ table }) => (
      <Box
        sx={(theme) => ({
          display: "flex",
          gap: "0.5rem",
          p: "16px 0px",
          justifyContent: "space-between",
        })}
      >
        <Box sx={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
          <MRT_GlobalFilterTextField table={table} />
        </Box>
        <Box sx={{ display: "flex", gap: "16px" }}>
          <RbacWrapper module={"country"} code={"add"}>
            <MgpButton
              variant="contained"
              onClick={handleNew}
              endIcon={<NoteAddIcon sx={{ marginTop: "-3px", fontSize: "16px !important" }} />}
            >
              Add Country
            </MgpButton>
          </RbacWrapper>
          <MgpButton
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={() => handleExportData('xlsx', "table")}
            endIcon={<FileDownloadIcon sx={{ fontSize: "16px !important" }} />}
            variant="contained"
          >
            Export Excel
          </MgpButton>
          <MgpButton
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={() => handleExportData('pdf', "table"
            )}
            endIcon={<FileDownloadIcon sx={{ fontSize: "16px !important" }} />}
            variant="contained"
          >
            Export PDF
          </MgpButton>
        </Box>
      </Box>
    ),
    renderRowActions: ({ row }) => {
      return (
        <>
          <RbacWrapper module={"country"} code={"edit"}>
            <Tooltip title={"Edit Country"} arrow>
              <IconButton
                size="small"
                onClick={() => {
                  setEdit(row.original);
                  console.log("🚀 ~ Country ~ row:", row);
                  setOpen(true);
                }}
              >
                <EditIcon sx={{ height: "16px" }} />
              </IconButton>
            </Tooltip>
          </RbacWrapper>
          <RbacWrapper module={"country"} code={"delete"}>
            <Tooltip title={"Delete Country"} arrow>
              <IconButton
                size="small"
                onClick={() => {
                  handleDelete(row.original);
                }}
              >
                <DeleteIcon sx={{ height: "16px" }} />
              </IconButton>
            </Tooltip>
          </RbacWrapper>
        </>
      );
    },
    state: { isLoading, columnOrder: columns.map((e) => e.accessorKey) },
    renderTableBody: () => {
      return isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : null;
    },
  });
  const handleSubmitClose = () => {
    setAlertOption(false);
  };
  const handleDelete = (row) => {
    setDeleting(row.country_id);
  };
  if (mainPageloading) {
    return <Loader open={mainPageloading} />;
  }
  return (
    <>
      {delete_ref && (
        <AlertDialog
          open={true}
          negative={() => {
            setDeleting(false);
          }}
          positive={(param) => {
            setMainPageloading(true)
            DeleteCountry({
              variables: { countryId: Number(param) }, onCompleted: () => {
                setDeleting(false);
                setMainPageloading(false);
                setAlertOption(true);
                setMessage("Country Removed Successfully");
                setAlertType("success")
              }
            });
          }}
          param={delete_ref}
          title={"Country Deletion"}
          description={"Are you sure you want to delete this country?"}
        />
      )}

      <MgpModal
        title={edit.country_id ? "Update Country" : "Add Country"}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <UpdateCountry
          setAlertOption={setAlertOption}
          setMainPageloading={setMainPageloading}
          setMessage={setMessage}
          setAlertType={setAlertType}
          edit={edit}
          closed={() => {
            setOpen(false);
          }}
        />
      </MgpModal>

      <Stack>
        <MgpText variant="h5">COUNTRY LIST</MgpText>
        <MgpTable table={table} />
      </Stack>
      <MgpAlertBar
        open={alertOption}
        setOpen={handleSubmitClose}
        alertType={alertType}
        message={message}
      />
    </>
  );
};
